import {Avatar, HeaderIconButton, Tooltip} from '@mds/mds-reactjs-library'
import {useContext} from 'react'

import UserContext from '../../../context/UserContext'

import style from './UserAvatar.module.css'

const UserAvatar = (props: any) => {
  const currentUser = useContext(UserContext)

  if (!currentUser) {
    return null
  }

  return (
    <HeaderIconButton {...props}>
      <Tooltip content={currentUser.name} dark={false} placement="left">
        <HeaderIconButton {...props}>
          <Avatar alt={currentUser.name} className={style.avatarContainer} src={currentUser.picture} />
        </HeaderIconButton>
      </Tooltip>
    </HeaderIconButton>
  )
}

export default UserAvatar
